export default __webpack_public_path__ + "static/media/pay respects 7.17b9c540.png";